import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export interface RequestOption {
  minHeight: any;
  value: string;
  label: string;
  icon?: string;
  description?: string;
  centerIcon?: boolean;
}

@Component({
    selector: 'app-request-card-selection',
    templateUrl: './request-card-selection.component.html',
    styleUrls: ['./request-card-selection.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RequestCardSelectionComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class RequestCardSelectionComponent implements ControlValueAccessor {
  @Input() options: RequestOption[] = [];
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() cssClass: string = '';
  @Input() labelBold: boolean = true;
  @Input() formControl?: FormControl;

  private _value: string | null = null;
  private onChange = (value: string | null) => { };
  private onTouched = () => { };

  constructor(private translateService: TranslateService) {}

  get value(): string | null {
    return this._value;
  }

  set value(val: string | null) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  get showError(): boolean {
    return !!(
      this.formControl &&
      this.formControl.invalid &&
      (this.formControl.touched || this.formControl.dirty)
    );
  }

  get errorMessage(): string | null {
    if (!this.formControl?.errors) return null;
    
    const errorKey = Object.keys(this.formControl.errors)[0];
    
    if (errorKey === 'required') {
      return this.translateService.instant('This field is required.');
    }
    
    return this.translateService.instant('Invalid selection.');
  }

  selectOption(optionValue: string) {
    this.value = optionValue;
  }

  isSelected(optionValue: string): boolean {
    return this.value === optionValue;
  }

  writeValue(value: string | null): void {
    this._value = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}